import {applyMiddleware, createStore as createReduxStore} from "redux";
import thunkMiddleware from "redux-thunk";

import {
    reducers as assignmentReducers,
    type Action as AssignmentAction,
} from "@khan/assignments-store";
import {type State as AssignmentState} from "@khan/assignments-types";
import {createCompose} from "@khan/util-redux-create-compose";

import {type Action as ContentAction} from "./actions.ts";
import {
    Reducers as ContentReducers,
    type State as ContentState,
} from "./reducers.ts";

const compose = createCompose({
    reduxDevtoolsOptions: {
        name: "Classroom Store",
    },
});

export type State = ContentState & AssignmentState;

type Action = ContentAction | AssignmentAction;

const reducers = {
    ...ContentReducers,
    ...assignmentReducers,
} as const;

// Special version of combineReducers to send the entire state in as an
// optional third parameter.
function combineReducers(reducers: any) {
    return (allState: any | null | undefined = {}, action: Action) => {
        const reducerKeys = Object.keys(reducers);

        return reducerKeys.reduce((state: any, key: string) => {
            const reducer = reducers[key];
            const childState = state[key];

            const newChildState = reducer(childState, action, state);

            if (childState !== newChildState) {
                return {...state, [key]: newChildState};
            }

            return state;
        }, allState);
    };
}

let store = null;

export function createStore(initialState?: Partial<State> | null): any {
    if (store) {
        return store;
    }

    const enhancers = compose(applyMiddleware(thunkMiddleware));

    const reducer = combineReducers(reducers);

    // @ts-expect-error - TS2322 - Type 'Store<string | number | symbol, AnyAction> & { dispatch: unknown; }' is not assignable to type 'null'. | TS2345 - Argument of type 'Partial<State>' is not assignable to parameter of type 'DeepPartial<string | number | symbol>'.
    store = createReduxStore(reducer, initialState || {}, enhancers);

    return store;
}
